import Bold from '@tiptap/extension-bold';

/**
 * Change the tag from <strong> to <b>
 */
export default Bold.extend({
  renderHTML({ HTMLAttributes }: { HTMLAttributes: Record<string, any> }) {
    return ['b', HTMLAttributes];
  },

  parseHTML() {
    return [
      { tag: 'b' },
    ];
  },
});
